<app-table-card-layout
    #cardLayout
    title="Inspections"
    [isLoading]="isDCPolicyLoaded"
    [failed]="dcPolicyFailed"
    [hasData]="inspections.length > 0"
    [noDataMessage]="globalMessages.noDataAvailabelMsg"
    [errorMessage]="globalMessages.serviceMsgError"
    (retry)="retryDCPolicy()">

    <div headerActions [class.d-none]="isDCPolicyLoaded">
        <lib-button
            [libIcon]="'new-window-open'"
            [buttonText]="'Go to Inspections'"
            [buttonSize]="'small'"
            [buttonTheme]="'secondary'"
            [disabled]="true"
        ></lib-button>
    </div>

    @if (inspections.length > 0) {
        <div [class.d-none]="isDCPolicyLoaded" class="d-flex flex-column psic-gap-6">
        @if (!cardLayout.isCompact()) {
            <!-- Standard table view -->
            <div class="table-container" [class.table-container--collapsed]="!showAll && inspections.length > 3">
                <table class="inspections-table">
                    <thead>
                        <tr>
                            <th class="disclaimer-bold">Date ordered</th>
                            <th class="disclaimer-bold">Date received</th>
                            <th class="disclaimer-bold">Type</th>
                            <th class="disclaimer-bold psic-p-4">vendor</th>
                            <th class="disclaimer-bold text-center">Inspection Report</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (inspection of displayedInspections; track inspection; let i = $index) {
                        <tr [class.active]="selectedRow === i">
                            <td class="disclaimer">{{ inspection.dateOrdered }}</td>
                            <td class="disclaimer">{{ inspection.dateReceived }}</td>
                            <td class="disclaimer">{{ inspection.type }}</td>
                            <td class="disclaimer">{{ inspection.vendor }}</td>
                            <td class="text-center" (click)="$event.stopPropagation()">
                                @if (hasInspectionDocument(inspection)) {
                                    <mat-icon
                                        class="mat-icon-24 p3-50-color"
                                        [svgIcon]="'external-link'"
                                        (click)="viewInspectionDocument(inspection, i)"
                                        title="Open in Document Hub"
                                    ></mat-icon>
                                } @else {
                                    <span class="icon-wrapper-disabled">
                                        <mat-icon
                                            class="mat-icon-24 icon-disabled"
                                            [svgIcon]="'external-link'"
                                            title="No inspection document available for this term"
                                        ></mat-icon>
                                    </span>
                                }
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
        } @else {
            <!-- Compact 2-column key-value view -->
            <div class="compact-list d-flex flex-column psic-gap-6" [class.compact-list--collapsed]="!showAll && inspections.length > 3">
                @for (inspection of displayedInspections; track inspection; let i = $index) {
                    <div class="compact-card" [class.active]="selectedRow === i">
                        <table class="compact-table">
                            <tbody class="d-flex flex-column psic-gap-3 psic-py-3">
                                <tr>
                                    <td class="compact-label disclaimer-bold">Date ordered</td>
                                    <td class="compact-value disclaimer">{{ inspection.dateOrdered }}</td>
                                </tr>
                                <tr>
                                    <td class="compact-label disclaimer-bold">Date received</td>
                                    <td class="compact-value disclaimer">{{ inspection.dateReceived }}</td>
                                </tr>
                                <tr>
                                    <td class="compact-label disclaimer-bold">Type</td>
                                    <td class="compact-value disclaimer">{{ inspection.type }}</td>
                                </tr>
                                <tr>
                                    <td class="compact-label disclaimer-bold">Vendor</td>
                                    <td class="compact-value disclaimer">{{ inspection.vendor }}</td>
                                </tr>
                                <tr>
                                    <td class="compact-label disclaimer-bold">Report</td>
                                    <td class="compact-value" (click)="$event.stopPropagation()">
                                        @if (hasInspectionDocument(inspection)) {
                                            <mat-icon
                                                class="mat-icon-24 p3-50-color"
                                                [svgIcon]="'external-link'"
                                                (click)="viewInspectionDocument(inspection, i)"
                                                title="Open in Document Hub"
                                            ></mat-icon>
                                        } @else {
                                            <span class="icon-wrapper-disabled">
                                                <mat-icon
                                                    class="mat-icon-24 icon-disabled"
                                                    [svgIcon]="'external-link'"
                                                    title="No inspection document available for this term"
                                                ></mat-icon>
                                            </span>
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        }

        @if (displayedInspections.length < inspections.length) {
            <div class="d-flex flex-row justify-content-center align-items-center psic-pb-3 w-100">
                <lib-button
                    [disabled]="false"
                    [buttonType]="'borderless'"
                    [buttonSize]="'medium'"
                    [buttonText]="'Show more'"
                    [libIcon]="'chevron-down'"
                    (callback)="loadMore()"
                ></lib-button>
            </div>
        } @else if (showAll && inspections.length > 3) {
            <div class="d-flex flex-row justify-content-center align-items-center psic-pb-3 w-100">
                <lib-button
                    [disabled]="false"
                    [buttonType]="'borderless'"
                    [buttonSize]="'medium'"
                    [buttonText]="'Show less'"
                    [libIcon]="'chevron-up'"
                    (callback)="showLess()"
                ></lib-button>
            </div>
        }
        </div>
    }
</app-table-card-layout>
